export class CustomerDeliverItem {
  id?: number;
  productId?: number;
  currentPrice?: number;
  quantity?: number;
  customerDeliverId?: number;
}
